/* eslint-disable semi,semi-style */
import React, { FunctionComponent } from 'react'

const types = {
  needauth: {
    img: 'https://view.didistatic.com/static/dcms/31nwv1czz1k06dmw2l_402x442_compress.png',
    title: '没有权限',
  },
  comming: {
    img: 'https://view.didistatic.com/static/dcms/31nwv1czz1k06dmw2l_402x442_compress.png',
    title: '敬请期待',
  },
}

interface ToolsProps {
  type: 'needauth' | 'comming';
}

const Tools: FunctionComponent<ToolsProps> = ({ type }) => {
  const obj = types[type]
  return (
    <div style={{ height: 'calc(100vh - 64px)', display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
      <img
        style={{ width: 201, height: 'auto' }}
        src={obj.img}
      />
      <p style={{ color: '#999', marginTop: 12, fontSize: 20 }}>{obj.title}</p>
    </div>
  )
}

export default Tools;